import React from 'react'
import PropTypes from 'prop-types'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'
import RowButton from 'components/atoms/row-button'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const propTypes = {
  onChangeBrandStatus: PropTypes.func
}

/**
 * Columns definition for Cms Community Favorite Brand Table
 * @param {Function} onChangeBrandStatus - function that will handle on change brand status (is_active)
 */
const cmsHomepageSectionCommunityFavoriteTableColumns = ({ onActionButtonClick }) => {

  // Custom Cell
  // Used to modify the cell in specific columns
  const LabelCell = (row) => {
    let isActive = row.row.original.is_active ? 'Active' : 'Not Active'


    return (
      `${row.cell.value} (${isActive})`
    )
  }

  const ImageCell = (row) => <img style={{ width: '8rem' }} src={ row.cell.value } />
  const UrlCell   = (row) => (
    <a
      className='text-primary'
      href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/brands/${row.cell.value}` }
      target='_blank' rel='noopener noreferrer'
    >
      { `brands/${row.cell.value}` }
    </a>
  )

  const ActionCell     = ({ cell: { row } }) => (
    <RowButton
      data={ row.original }
      color='primary'
      onClick={ () => onActionButtonClick(row) }
      text='Edit'
    />
  )
  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header         : 'Id',
        accessor       : 'id',
        disableFilters : true
      },
      {
        Header   : 'Name',
        accessor : 'label',
        id       : 'label',
        Cell     : LabelCell
      },
      {
        Header         : 'Url Key',
        accessor       : 'url',
        disableFilters : true,
        Cell           : UrlCell
      },
      {
        Header         : 'Image',
        accessor       : 'image',
        disableFilters : true,
        Cell           : ImageCell
      },
      {
        Header         : 'Action',
        accessor       : 'is_active',
        disableFilters : true,
        Cell           : ActionCell
      }
    ]
  )
}

cmsHomepageSectionCommunityFavoriteTableColumns.propTypes = propTypes

export default cmsHomepageSectionCommunityFavoriteTableColumns
